module.exports = __webpack_public_path__ + "static/note-styling-dont-5d0a1672e5f9ae20f3dc416fff649972.png";